import {
  Button,
  Container,
  CssBaseline,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material'
import React, { useEffect } from 'react'
import Movie from 'redux/models/movie'
import { VerificationActions, VerificationStoreStates } from '.'
import Modal from './Modal'
import { CSVLink, IDText } from './styles'

type OwnProps = {}

type VerificationProps = OwnProps & VerificationStoreStates & VerificationActions

const Verification = (props: VerificationProps) => {
  const { movies, cancel, clear } = props

  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))

  const [activeMovie, setActiveMovie] = React.useState<Movie | null>(null)

  const csvData = movies.items.map((item) => item.csvData)
  csvData.unshift(Movie.csvHeader)

  const items = movies.items.filter((item) => !item.isVerified && !item.isCancelled)

  const onVeify = (isValid: boolean) => {
    if (!activeMovie) return
    props.verify({ item: activeMovie, isValid })
  }

  useEffect(() => {
    props.load()
  }, [])

  return (
    <Container>
      <CssBaseline />
      <Paper sx={{ mb: 2 }}>
        <Toolbar>
          <Grid size="grow">
            <Typography variant="h6" style={{ flex: '1 1 100%' }}>
              動画像リスト
            </Typography>
          </Grid>
          <Grid>
            <Button variant="contained" component="label" color="primary">
              <CSVLink filename="movies.csv" target="_blank" data={csvData} />
              CSV エクスポート
            </Button>
          </Grid>
        </Toolbar>
        <TableContainer>
          <Table size="small" aria-label="word list">
            <TableHead>
              <TableRow>
                <TableCell>発話ワード</TableCell>
                {!mdDown && (
                  <>
                    <TableCell>ユーザ</TableCell>
                    <TableCell>投稿日時</TableCell>
                  </>
                )}
                <TableCell align="right">検証</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((row) => (
                <TableRow key={row.id}>
                  {!mdUp && (
                    <TableCell component="td" scope="row">
                      <IDText component="p">{row.createdDate}</IDText>
                      {row.word}
                    </TableCell>
                  )}

                  {!mdDown && (
                    <>
                      <TableCell component="td" scope="row">
                        {row.word}
                        <IDText component="span">&emsp;{row.readingWordId}</IDText>
                      </TableCell>
                      <TableCell component="td" scope="row">
                        {row.userName}
                        <IDText component="span">&emsp;{row.userId}</IDText>
                      </TableCell>
                      <TableCell component="td" scope="row">
                        {row.createdDate}
                      </TableCell>
                    </>
                  )}
                  <TableCell component="td" scope="row" align="right" sx={{ width: 150 }}>
                    <Button variant="contained" component="label" color="primary" onClick={() => setActiveMovie(row)}>
                      動画像を検証
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {activeMovie && (
        <Modal
          item={activeMovie}
          movies={movies}
          onVerify={(isValid) => onVeify(isValid)}
          onCancel={cancel}
          onClose={() => {
            clear()
            setActiveMovie(null)
          }}
        />
      )}
    </Container>
  )
}

export default Verification
